
export const PAGE = {
    LOGIN: "login",
    SIGNUP: "signup",
    PRIVACY_POLICY: "privacy-policy",
    REQUEST_RESET_PASSWORD: "request-reset-password",
    RESET_PASSWORD: "reset-password",
    ABOUT_V2: "about-v2",
    ABOUT: "about",

    TEACHER: "teacher",
    STUDENT: "student",
    DASHBOARD: "dashboard",
    OVERVIEW: "overview",
    CLASS: "class",
    ADMIN: "admin",
    LIBRARY: "library",
    EDIT: "edit",
    TOPIC_EDIT: "topicedit",
    QUESTION_EDIT: "questionedit",
    HOMEWORK: "homework",
    ASSIGN: "assign",
    MANUAL_EDIT: "manualedit",
    AIEDIT: "aiedit",
    AIEDIT_RESULT: "aieditresult",
    CLASSVIEW: "classview",
    STUDENTVIEW: "studentview",
    AI_BOT: "aibot",
    CHAT: "chat",
    PRACTICE: "practice",
    HOME: "home",
    LIBRARY_IMPORT: "libraryimport",
    SETTING: "setting",
    PROFILE: "profile",
    SELF_ASSESS: "self-assess",
    ACCESS_RESTRICTED: "access-restricted",
    GAMIFICATION: "gamification",
    CONFIG: "config",
    RECORDS: "records",
    LEADERBOARDS: "leaderboards",
    EXPERT: "expert",
    ANNOTATION: "annotation",
}

export const ROUTE = {
    HOME: "/",
    LOGIN: "/auth/login",
    SIGNUP: "/auth/signup",
    PRIVACY_POLICY: "/auth/privacy-policy",
    RESET_PASSWORD: "/auth/reset-password",
    REQUEST_RESET_PASSWORD: "/auth/request-reset-password",
    ACCESS_RESTRICTED: "/auth/access-restricted",
    ABOUT_V2: "/auth/about-v2",
    ABOUT: "/auth/about",

    TEACHER: {
        DASHBOARD: "/teacher/dashboard",
        OVERVIEW: "/teacher/dashboard/overview",
        CLASS_ADMIN: "/teacher/class/admin",
        CLASS_OVERVIEW: "/teacher/class/overview",
        HOMEWORK: "/teacher/homework",
        HOMEWORK_OVERVIEW: "/teacher/homework/overview",
        HOMEWORK_CLASSVIEW: "/teacher/homework/classview",
        HOMEWORK_STUDENTVIEW: "/teacher/homework/studentview",
        HOMEWORK_EDIT: "/teacher/homework/edit",
        HOMEWORK_AI_EDIT: "/teacher/homework/aiedit",
        HOMEWORK_AI_EDIT_RESULT: "/teacher/homework/aieditresult",
        HOMEWORK_MANUAL_EDIT: "/teacher/homework/manualedit",
        HOMEWORK_ASSIGN: "/teacher/homework/assign",
        PRACTICE_CLASSVIEW: "/teacher/practice/classview",
        LIBRARY_EDIT: "/teacher/library/edit",
        LIBRARY_TOPIC_EDIT: "/teacher/library/topicedit",
        LIBRARY_QUESTION_EDIT: "/teacher/library/questionedit",
        GAMIFICATION_CONFIG: "/teacher/gamification/config",
        GAMIFICATION_RECORDS: "/teacher/gamification/records",
        GAMIFICATION_LEADERBOARDS: "/teacher/gamification/leaderboards",
        EXPERT_ANNOTATION: "/teacher/expert/annotation",
    },

    STUDENT: {
        DASHBOARD: "/student/dashboard",
        OVERVIEW: "/student/dashboard/overview",
        HOMEWORK: "/student/homework/edit",
        PRACTICE_HOME: "/student/practice/home",
        PRACTICE_EDIT: "/student/practice/edit",
        AI_BOT: "/student/aibot/chat",
        SETTING_PROFILE: "/student/setting/profile",
        SELF_ASSESS: "/student/self-assess/home",
    },
}
